import { Component, h, Host, Prop, State } from '@stencil/core';
import { DetailProduct, ListProduct } from '~model/product';
import { get } from '~service/shop-service';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-product-related-articles-slider',
  styleUrl: './product-related-articles-slider.scss',
})
export class ProductRelatedArticlesSlider {
  @Prop() show: 'relatedArticles' | 'similarArticles';
  @State() loading = false;

  products: ListProduct[] = [];

  async componentWillLoad() {
    this.loading = true;
    try {
      const product: DetailProduct = await get(window.location.href);
      this.products = product[this.show] || [];
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }

  render() {
    if (!this.products) {
      return null;
    }

    return (
      <Host hidden={this.products.length === 0} class="product-slider-wrap">
        <h3>{translate('sw.' + this.show + '.headline')}</h3>
        <uvex-slider-product class="carousel-shopware-style">
          {this.products.map(product => {
            return (
              <div class="carousel-slide">
                <uvex-product product={product} />
              </div>
            );
          })}
        </uvex-slider-product>
        <uvex-spinner active={this.loading} />
      </Host>
    );
  }
}
